import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useAutocompleteService from '../../customHooks/usePlacesAutocompleteService';
import { PrimaryButton } from '../../styledComponents/buttons';
import { CommonFlex, PageTitle } from '../../styledComponents/common';
import OfficeList from './OfficesList';

const Offices = ({
  getOrganizationMembersList,
  orgMembersList,
  isLoading,
  getOfficesList,
  officesList,
  officeDetails,
  setOfficeDetails,
  history,
  clearOfficeCreatedUpdated,
  getPublicZoneList,
  publicZoneList,
}) => {
  const { t } = useTranslation();

  const [currentPage, setCurrentPage] = useState('list');
  //search
  const [searchTerm, setSearchTerm] = useState('');
  const [currentSearchedTerm, setCurrentSearchedTerm] = useState('');
  // delete
  const [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false);

  const [selectedOffice, setSelectedOffice] = useState(officesList[0]);

  // details states
  const [singleAddressMarker, setSingleAddressMarker] = useState(null);
  const [addressInput, setAddressInput] = useState('');

  // map states
  const [map, setMap] = useState(null);

  const {
    geocoderService,
    getPlacePredictions,
    placePredictions,
    setPlacePredictions,
    isPredictionsLoading,
    refreshSessionToken,
  } = useAutocompleteService({ map, debounceTimeout: 500 });

  useEffect(() => {
    getOfficesList({
      page: null,
      office_name: null,
    });
  }, []);

  useEffect(() => {
    if (currentPage && currentPage === 'list') {
      clearOfficeCreatedUpdated();
    }
  }, [currentPage]);

  useEffect(() => {
    if (officesList && officesList.length > 0 && currentPage === 'list') {
      if (map) {
        handleFitBounds(officesList);
      }
    }
  }, [officesList, map]);
  useEffect(() => {
    setSelectedOffice(officesList[0]);
    handleSelectOffice(officesList[0]);
  }, [officesList]);

  const handleFitBounds = list => {
    if (map) {
      if (list.length === 1) {
        const location = {
          lat: parseFloat(list[0].latitude),
          lng: parseFloat(list[0].longitude),
        };
        handleMapPanAndZoomToSingleLocation(location);
      } else {
        const bounds = new window.google.maps.LatLngBounds();
        list.forEach(place => {
          const position = new window.google.maps.LatLng(
            parseFloat(place.latitude),
            parseFloat(place.longitude),
          );
          bounds.extend(position);
        });
        map.fitBounds(bounds, 20);
      }
    }
  };

  const handleReverseGeocode = coord => {
    if (geocoderService && coord) {
      setPlacePredictions([]);
      geocoderService
        .geocode({ location: coord })
        .then(results => {
          if (results.results && results.results.length) {
            setAddressInput(results.results[0].formatted_address);
          } else {
            setAddressInput(`${coord.lat()}, ${coord.lng()}`);
          }
        })
        .catch(e => {
          console.log(e);
        });
    }
  };

  const onSearchTermChange = e => {
    const { value } = e.target;
    setSearchTerm(value);
  };

  const handleSelectOffice = office => {
    if (office && office.id) {
      setSelectedOffice(office);
      if (map) {
        map.panTo({
          lat: parseFloat(office.latitude),
          lng: parseFloat(office.longitude),
        });
        map.setZoom(17);
      }
    }
  };

  const handleMapPanAndZoomToSingleLocation = location => {
    if (map) {
      map.panTo(location);
      map.setZoom(17);
    }
  };

  const toggleDeleteModal = officeId => {
    // if (!isDeleteModalVisible) {
    //   setDeleteOfficeId(officeId);
    // }
    setIsDeleteModalVisible(!isDeleteModalVisible);
  };

  return (
    <div className="content">
      {/* <DeleteOfficeModal
        isOpen={isDeleteModalVisible}
        toggle={() => setIsDeleteModalVisible(!isDeleteModalVisible)}
        // handleDelete={handleDeleteOffice}
        isLoading={false}
      /> */}
      <CommonFlex justifyContent="space-between">
        <PageTitle>{t('offices')}</PageTitle>
        {currentPage === 'list' &&
          localStorage.getItem('user_role') === 'admin' &&
          !localStorage.getItem('viewer_role') && (
            <PrimaryButton onClick={() => history.push('create-office')}>
              {t('create_office')}
            </PrimaryButton>
          )}
      </CommonFlex>
      {currentPage === 'list' ? (
        <OfficeList
          isLoading={isLoading}
          officesList={officesList}
          selectedOffice={selectedOffice}
          selectOffice={handleSelectOffice}
          toggleDeleteModal={toggleDeleteModal}
          searchTerm={searchTerm}
          onSearchTermChange={onSearchTermChange}
          history={history}
        />
      ) : null}
    </div>
  );
};

export default Offices;
